import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { DetailsSection } from './components/DetailsSection';
import { FAQSection } from './components/FAQSection';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-cream-light font-sans text-brown overflow-x-hidden" data-id="element-0">
      <Hero data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <SolutionSection data-id="element-3" />
      <DetailsSection data-id="element-4" />
      <FAQSection data-id="element-5" />

      <footer className="bg-brown text-cream-light py-12 text-center" data-id="element-6">
        <div className="max-w-5xl mx-auto px-6" data-id="element-7">
          <p className="text-cream-dark/60 text-sm mb-4" data-id="element-8">
            Este producto no sustituye el consejo médico profesional. Consulta a
            tu médico antes de realizar cambios en tu dieta o estilo de vida.
          </p>
          <p className="text-cream-dark/80" data-id="element-9">
            © {new Date().getFullYear()} Plan de Vitalidad Menopáusica. Todos
            los derechos reservados.
          </p>
        </div>
      </footer>
    </div>;
}